import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthApi } from "api/auth";
import { CheckCreditAgentLineReponse } from "api/auth/type";
import { featureApi } from "api/feature";

export const getFeature = createAsyncThunk(
  "feature/getFeature",
  async (username: string, { rejectWithValue }) => {
    try {
      const response = await featureApi.toggleFeature(username);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getDataPermission = createAsyncThunk(
  "feature/getDataPermission",
  async (username: string, { rejectWithValue }) => {
    try {
      const response: CheckCreditAgentLineReponse =
        await AuthApi.getCheckCreditAgentLine(username);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
